import React from "react";
import ReactDOM from "react-dom/client";
import { useLocation } from "react-router-dom"; // Add this import

import {
  createBrowserRouter, RouterProvider,
} from "react-router-dom";

import Sewp5Public from "../../routes/sewp5public";
import ContractHolders from "../../components/ContractHolders/ContractHolders";
import FedRamp from "../../components/FedRamp/FedRamp";
import OrderApp from "../../components/OrderApp/OrderApp";
import ProgramPerformance from "../../components/ProgramPerformance/ProgramPerformance";
import ApprovedContractors from "../../components/ApprovedContractors/ApprovedContractors";

// Create a quick debug component
const Debug404 = () => {
  const location = useLocation();
  return (
    <div style={{ padding: "20px", background: "#fee", color: "red" }}>
      <h2>React Router 404 Debugger</h2>
      <p>React Router is looking for this path: <b>{location.pathname}</b></p>
      <p>But it doesn't match any of your defined routes!</p>
    </div>
  );
};

const router = createBrowserRouter([
  {
    path: "/", 
    element: <Sewp5Public/>, 
    children: [
      { path: "contractholders", element: <ContractHolders/> },
      { path: "fedramp", element: <FedRamp/> },
      { path: "orderapp", element: <OrderApp/> },
      { path: "chperformance", element: <ProgramPerformance/> },
      { path: "approvedcontractors", element: <ApprovedContractors/> },
	  { path: "*", element: <Debug404/> }
    ],
  }
], 
{
  basename: "/sewpv/sewp5public" 
});

ReactDOM.createRoot(document.getElementById("root")).render(<React.StrictMode>
  <RouterProvider router={router}/>
</React.StrictMode>);